import { render, staticRenderFns } from "./HeaderWAP.vue?vue&type=template&id=dacbafcc&scoped=true"
import script from "./HeaderWAP.vue?vue&type=script&lang=js"
export * from "./HeaderWAP.vue?vue&type=script&lang=js"
import style0 from "./HeaderWAP.vue?vue&type=style&index=0&id=dacbafcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacbafcc",
  null
  
)

export default component.exports